<template>
  <b-modal
      id="modal-config-imagem"
      cancel-variant="outline-secondary"
      ok-title="Salvar"
      cancel-title="Cancelar"
      centered
      title="Configurar Imagem"
      size="md"
      @ok="saveImagem(currentImage)"
      :ok-disabled="!currentImage.caminho || $store.getters['slsTemplateImagem/getIsLoading']"
      @cancel="resetData"
      @close="resetData"
      no-close-on-esc
      no-close-on-backdrop
  >
    <b-form ref="refFormAddImagem">
      <b-row>
        <b-col cols="12" class="d-flex justify-content-center mb-2">
          <div class="molde-img">
            <b-img
                v-if="imagemPresenter"
                :src="imagemPresenter"
                fluid alt="Pré-visualização"
                style="max-width: 350px; max-height: 261px;min-width: 350px; min-height: 261px;"
            />
            <b-img
                v-else
                :src="imagemPadrao"
                fluid
                alt="Pré-visualização"
                style="max-width: 350px; max-height: 261px;min-width: 350px; min-height: 261px;"
            />
          </div>
        </b-col>

        <b-col cols="12">
          <b-form-group label="Foto do produto">
            <b-form-file
                v-model="currentImage.caminho"
                ref="refCaminho"
                placeholder="Escolha um arquivo ou arraste-o aqui..."
                drop-placeholder="Solte o arquivo aqui..."
                accept="image/*"
                @change="changeImg($event)"
            ></b-form-file>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-checkbox
              v-model="currentImage.imagem_principal"
              :value="1"
              :unchecked-value="0"
          >
            Imagem principal
          </b-form-checkbox>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>
<script>
import SlsTemplateImagemService from '@/services/SistemaDKP/sls-template-imagem.service';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';
import { IMAGEM_PADRAO } from '@/utils/imagemUrl';

const slsTemplateImagemService = new SlsTemplateImagemService();
export default {
  props: {
    value: {
      type: Object,
      default: () => ({
        des_cor: null,
        des_marca: null,
      }),
    },
    marcaNome: {
      type: String,
      default: '',
    },
    familiaDescricao: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      imagemPadrao: IMAGEM_PADRAO,
      imagemPresenter: null,
      imagemFile: null,
    };
  },
  watch: {
    currentImage: {
      handler(newValue) {
        if (typeof newValue.caminho === 'object') {
          this.imagemPresenter = newValue.caminho_base64;
          this.imagemFile = newValue.caminho;
        }
      },
      deep: false,
    },
  },
  computed: {
    currentImage: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    saveImagem(e) {
      const isValidPathString = (val) => typeof val === 'string'
        && val.length > 0
        && !val.startsWith('data:image');
      const caminhoFinal = this.currentImage.caminho_upload
        || (isValidPathString(this.currentImage.caminho) ? this.currentImage.caminho : null)
        || (isValidPathString(this.currentImage.caminho_base64) ? this.currentImage.caminho_base64 : null);

      if (!caminhoFinal) {
        this.notifyWarning('Nenhuma imagem foi enviada. Tente novamente.');
        return;
      }

      this.$emit('addImagem', {
        ...e,
        cdn_cor: null,
        des_cor: null,
        cdn_embalag: null,
        des_embalag: null,
        exibe_cores: 0,
        ordem: null,
        caminho: caminhoFinal,
      });
      this.resetData();
    },
    notifyWarning(message) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Atencao',
          text: message,
          icon: 'AlertTriangleIcon',
          variant: 'warning',
        },
      });
    },
    async uploadImagem(file, nomeArquivo) {
      if (!this.marcaNome || !this.familiaDescricao) {
        this.notifyWarning('Selecione marca e referencia antes de enviar a imagem.');
        return;
      }

      this.$store.commit('slsTemplateImagem/setIsLoading', true);
      try {
        const response = await slsTemplateImagemService.uploadLocalImagem(
          file,
          this.marcaNome,
          this.familiaDescricao,
          nomeArquivo,
        );
        this.currentImage.caminho_upload = response.caminho;
      } catch (error) {
        this.currentImage.caminho_upload = null;
        this.notifyWarning(error.message || 'Erro ao enviar a imagem.');
      } finally {
        this.$store.commit('slsTemplateImagem/setIsLoading', false);
      }
    },
    resetData() {
      this.$emit('closeModal');
      this.currentImage = {
        imagem_principal: 0,
        exibe_cores: 0,
        ordem: null,
        des_marca: null,
        cdn_embalag: null,
        cdn_cor: null,
        caminho: null,
        caminho_base64: null,
        caminho_upload: null,
      };
      this.imagemPresenter = null;
    },
    changeImg(event) {
      event.preventDefault();
      let file = null;
      if (event.dataTransfer) {
        file = event.dataTransfer.files[0];
      } else {
        file = event.target.files[0];
      }

      if (file) {
        this.currentImage.caminho_upload = null;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imagemPresenter = e.target.result;
          this.currentImage.caminho_base64 = e.target.result;
        };
        reader.readAsDataURL(file);
        this.uploadImagem(file, file.name);
      }
    },
  },
};
</script>
